<script setup>
/**
 * FormControlProductVariablesOptionId
 * Composition-based wrapper around the One-to-Many Relationship control.
 * Structural Lockout: Evaluates product variant configurations on mount, hiding
 * its layout selector element if a root Option ID assignment has already been set.
 */
import { onMounted } from 'vue';
import FormControlTypeRelationshipOneToMany from '../form-control-type/FormControlTypeRelationshipOneToMany.vue';

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
});

// --- Lifecycle ---

onMounted(() => {
    /**
     * Data Integrity Lock: If this variant is already bound to a parent option group,
     * instantly make readonly to freeze values.
     */
    if (props.currentData?.optionId && props.field) {
        props.field.readonly = true;
    }
});
</script>

<template>
    <FormControlTypeRelationshipOneToMany
        v-if="!field.hidden"
        v-bind="$props"
        v-on="$listeners"
    />
</template>

<style scoped>
/* Core sizing and option rows inherit directly from FormControlTypeRelationshipOneToMany */
</style>